import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Dropdown } from "semantic-ui-react";
import { TitleCase } from "../../common";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import _ from "lodash";
const uuidv4 = require("uuid/v1");

class FilterLookup extends Component {
  constructor() {
    super();
    this.state = {
      LookupData: [],
      optionsData: [],
      gotLookup: false,
      loading: false
    };
  }

  componentWillMount() {
    let initialLookupData = [];

    let method = "result.sentItemsForms";
    let text = "form_title";
    let id = "form_id";
    if (this.props.filter_type === "user") {
      method = "result.sentItemsUsers";
      text = "user_name";
      id = "user_id";
    }

    var body = JSON.stringify({
      jsonrpc: "2.0",
      method: method,
      params: null,
      id: uuidv4()
    });

    var headers = {
      "x-rpc-auth-device": this.props.deviceId,
      "x-rpc-auth-session": this.props.sessionId,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    return fetch(this.props.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(data => {
        if (data.result === null) {
          initialLookupData = [];
        } else {
          initialLookupData = data.result.data.map(lookup => {
            return lookup;
          });
        }

        var optionsDataInit = [];
        initialLookupData.forEach(element => {
          optionsDataInit.push({
            text: TitleCase(element[text]),
            value: element[id]
          });
        });

        this.setState({
          optionsData: optionsDataInit,
          LookupData: initialLookupData,
          gotLookup: true
        });
      });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const different =
      this.state.LookupData !== nextState.LookupData ||
      this.props.selectedValue !== nextProps.selectedValue;
    return different;
  }

  handleChangeDD(e, d) {
    this.props.onSelect(this.props.filter_type, d.value);
  }

  renderSelect() {
    let placeholderText = "Form...";
    if (this.props.filter_type === "user") {
      placeholderText = "User...";
    }

    return (
      <span style={{ display: "inline-block", width: "100%" }}>
        <Dropdown
          className="cdc"
          style={{ width: "178px" }}
          loading={!this.state.gotLookup ? true : false}
          minCharacters={0}
          value={this.props.selectedValue}
          placeholder={placeholderText}
          onChange={this.handleChangeDD.bind(this)}
          fluid
          search
          selection
          options={this.state.optionsData}
        />
      </span>
    );
  }

  render() {
    if (this.state.optionsData.length < 2) {
      return null;
    }
    return (
      <div
        style={{
          marginLeft: "10px",
          verticalAlign: "top",
          display: "inline-block"
        }}
        className="formControlItem"
      >
        <Form.Field>{this.renderSelect()}</Form.Field>
      </div>
    );
  }
}

FilterLookup.propTypes = {
  filter_type: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedValue: PropTypes.string.isRequired,
  init: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  deviceId: state.informedWebApp.deviceId,
  sessionId: state.informedWebApp.sessionId,
  api: state.informedWebApp.api
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterLookup);



// WEBPACK FOOTER //
// ./src/components/FilterLookup/index.js